"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "permissions", {
  enumerable: true,
  get: function get() {
    return _permissions["default"];
  }
});
var _permissions = _interopRequireDefault(require("./permissions"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }